import { UiButton, UiCodeinputRefactor } from 'libs/raas-ui-react-components/src/components';
import React, { useState } from 'react';

import './Typography.scss'


export const TypographyPage = () => {

    const defaultValue = 'abcdefghijklmnñopqrstuvwxyz'

    const [value, setValue] = useState('abcdefghijklmnñopqrstuvwxyz');

    const updatevalue = (e: any) => {
        setValue(e?.target?.value || defaultValue);
    }

    return (
        <div style={{ margin: '100px' }}>
            <h1 className='titleTypography'>Typography</h1>
            <input onChange={(e: any) => updatevalue(e)} />
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>Style types</h3></legend>
                <label>.regular <p className="regular">{value}</p></label>
                <label>.semibold <p className="semibold">{value}</p></label>
                <label>.bold <p className="bold p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>4XL</h3></legend>
                <label>.xxxxl-regular <p className="xxxxl-regular p">{value}</p></label>
                <label>.xxxxl-bold <p className="xxxxl-bold p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>3XL</h3></legend>
                <label>.xxxl-regular<p className="xxxl-regular p">{value}</p></label>
                <label>.xxxl-bold<p className="xxxl-bold p">{value}</p></label>
                <label>.xxxl-capitular<p className="xxxl-capitular uppercase p">{value}</p></label>
                <label>.xxxl-bold-capitular<p className="xxxl-bold-capitular uppercase p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>2XL</h3></legend>
                <label>.xxl-regular<p className="xxl-regular p">{value}</p></label>
                <label>.xxl-bold <p className="xxl-bold p">{value}</p></label>
                <label>.xxl-capitular <p className="xxl-capitular uppercase p">{value}</p></label>
                <label>.xxl-bold-capitular <p className="xxl-bold-capitular uppercase p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>XL</h3></legend>
                <label>.xl-regular<p className="xl-regular p">{value}</p></label>
                <label>.xl-bold <p className="xl-bold p">{value}</p></label>
                <label>.xl-capitular <p className="xl-capitular uppercase p">{value}</p></label>
                <label>.xl-bold-capitular <p className="xl-bold-capitular uppercase p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>L</h3></legend>
                <label>.l-regular<p className="l-regular p">{value}</p></label>
                <label>.l-bold <p className="l-bold p">{value}</p></label>
                <label>.l-capitular <p className="l-capitular uppercase p">{value}</p></label>
                <label>.l-bold-capitular <p className="l-bold-capitular uppercase p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>M</h3></legend>
                <label>.m-regular<p className="m-regular p">{value}</p></label>
                <label>.m-bold <p className="m-bold p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>S</h3></legend>
                <label>.s-regular<p className="s-regular p">{value}</p></label>
                <label>.s-bold <p className="s-bold p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>XS</h3></legend>
                <label>.xs-regular<p className="xs-regular p">{value}</p></label>
                <label>.xs-bold <p className="xs-bold p">{value}</p></label>
            </fieldset>
            <hr />
            <fieldset className="fieldset ">
                <legend className="legend"><h3>HELPER</h3></legend>
                <label>.helper-regular<p className="helper-regular p">{value}</p></label>
                <label>.helper-semi-bold <p className="helper-semi-bold p">{value}</p></label>
                <label>.helper-bold <p className="helper-bold p">{value}</p></label>
            </fieldset>
            {/* <UiCodeinputRefactor></UiCodeinputRefactor> */}
            <UiButton idButton="boton" type="button" size="w100">Hola</UiButton>
        </div>

    )
}
